// import { selectUser } from "../../../redux/user/userSlice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "../../../app/hooks";
import { useParams } from "react-router";
import { RoutineInsUpdData } from "./RoutineInsUpdData";
import { RoutineInsUpdReview } from "./RoutineInsUpdReview";
import { routineInsert, routineUpdate, routineInsUpdSlice, selectRoutineInsUpd } from "../../../redux/routine/routineInsUpdSlice";
import ObjectInsUpd from "../../../features/base/page/ObjectInsUpd";
import { schoolSlice, selectSchool } from "../../../redux/school/schoolSlice";
import SchoolPageAvatar from "../../school/basics/SchoolPageAvatar";
import SchoolPageTitle from "../../school/basics/SchoolPageTitle";
import { routineSlice, selectRoutine } from "../../../redux/routine/routineSlice";
import RoutinePageTitle from "../basics/RoutinePageTitle";
import RoutinePageAvatar from "../basics/RoutinePageAvatar";
import PageAuthenticatedLoading from "../../../features/pages/PageAuthenticatedLoading";
import { routeRoutine } from "../../../routes/routine";
import { routeSchool } from "../../../routes/school";
import { ElementMissingContext } from "../../../features/base/ElementMissingContext";
import { TopBar } from "../../../features/top/TopBar";
import { schoolRoutinesSlice } from "../../../redux/school/schoolRoutinesSlice";

export function RoutineInsUpd() {
//   const user = useSelector(selectUser);
  const dispatch = useAppDispatch();
  const school = useSelector(selectSchool);
  const routineInsUpd = useSelector(selectRoutineInsUpd);
  const routine = useSelector(selectRoutine);
  const {schoolId, routineId} = useParams();

  console.log(`RoutineInsUpd: ${schoolId}/${routineId}`);
  if(!schoolId) {
    return <ElementMissingContext />;
  }

  const editing = routineId !== undefined;
  const breadcrumbTitle = editing ? "Editar Rotina" : "Nova Rotina";

  if(editing) {
    if(routineInsUpd.routine.schoolId === "" && routine.selected) {
      const changing = {
        ...routine.selected
      };
      dispatch(routineInsUpdSlice.actions.set(changing));
    }
  } else {
    if(routineInsUpd.routine.schoolId === "") {
      const changing = {
        ...routineInsUpd.routine
      };
      changing.schoolId = `${schoolId}`;
      dispatch(routineInsUpdSlice.actions.set(changing));
    }
  }

  const breadcrumbs = [
    { 
      label: school.selected?.name ? school.selected?.name : "Escola", 
      href: routeSchool(schoolId, "routine")
    },
    { label: breadcrumbTitle },
  ];

  const steps = [
    {
      name: "Dados da Rotina",
      component: <RoutineInsUpdData />,
      check: () => routineInsUpd.routine.name.length > 4,
    },
    {
      name: "Revisão",
      component: <RoutineInsUpdReview />,
    }
  ];

  const title = (editing) ? <RoutinePageTitle schoolId={schoolId} routineId={routineId} /> : <SchoolPageTitle schoolId={schoolId} />;
  const pageAvatar = (editing) ? <RoutinePageAvatar /> : <SchoolPageAvatar />;

  const buildContent = () => 
    <ObjectInsUpd 
        name="rotina" 
        submit={() => 
          (editing)
          ? dispatch(routineUpdate({routineId: routineId, routine: routineInsUpd.routine}))
          : dispatch(routineInsert({routine: routineInsUpd.routine}))
        } 
        backTo={ (editing) ? routeRoutine(schoolId, routineId) :  routeSchool(schoolId, "routine")}
        backCleanup={() => {
          dispatch(schoolRoutinesSlice.actions.clean());
          dispatch(routineInsUpdSlice.actions.clean());
        }}
        state={routineInsUpd.state} 
        steps={steps}
        edit={editing}
      />
    ;

  return <PageAuthenticatedLoading key="editUpdateRoutine"
        topbar={ <TopBar title={title} pageAvatar={pageAvatar} breadcrumbs={breadcrumbs} /> }
        loading={{
        states: editing ? [school.state, routine.state] : [school.state], 
        content: buildContent,
        error: "Erro ao carregar Departamento",
        retry: () => {
            dispatch(schoolSlice.actions.clean());
            dispatch(routineSlice.actions.clean());
        }
        }}
    />;

}
